import { useEffect, useRef } from "react";

export function useTimeOnPage(
  onTimeReached: () => void,
  timeOnPageDelay: number,
  isTimeOnPageEnabled: boolean,
  isModalOpened: boolean
) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  // Latest-ref so callers can pass inline arrows without resetting the timer
  // on every parent re-render.
  const onTimeReachedRef = useRef(onTimeReached);
  onTimeReachedRef.current = onTimeReached;

  const millisecondsDelay = timeOnPageDelay * 1000;

  useEffect(() => {
    if (!isTimeOnPageEnabled || isModalOpened) {
      return;
    }

    const startTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onTimeReachedRef.current();
      }, millisecondsDelay);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        clearTimeout(timerRef.current);
        return;
      }

      startTimer();
    };

    if (document.visibilityState === "visible") {
      startTimer();
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearTimeout(timerRef.current);
    };
  }, [isTimeOnPageEnabled, isModalOpened, millisecondsDelay]);
}
